import {useCallback} from "react";
import {postBlockUser} from "../api";
import {AdminAction} from "../types";
import {useToast} from "use-toast-mui";

export const useBlockUser = () => {
    const toast = useToast();

    const blockUser: AdminAction = useCallback(async (activationKey: string): Promise<void> => {
        try {
            await postBlockUser(activationKey);
        } catch (error) {
            toast.error("Something went wrong when blocking a user.");
        }
    }, [toast])

    return {blockUser}
}
